import { Tooltip } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const STooltip = styled(Tooltip)``;
